import { lazy } from "react";

// sessionStorage key: when this tab last reloaded because a lazy file was missing.
const RELOAD_AT_KEY = "lazyChunkReloadAt";
// A second failure within this window is a real error (e.g. offline), not an outdated page.
const RELOAD_GUARD_MS = 10_000;

// React.lazy for code that is split into its own file (e.g. the Form.io pages). After a deploy, a
// page still running the previous version can ask for a file name the new build no longer has; the
// download fails. Instead of showing an error, reload once so the page runs the new version (which
// knows the new file names). If it fails again right after that reload, the error is real: rethrow.
export default function lazyWithReload(importer) {
	return lazy(() =>
		importer().catch((error) => {
			let lastReload = 0;
			try {
				lastReload = Number(sessionStorage.getItem(RELOAD_AT_KEY)) || 0;
			} catch {
				// Storage unavailable: fall through to the reload, guarded by nothing.
			}

			if (Date.now() - lastReload > RELOAD_GUARD_MS) {
				try {
					sessionStorage.setItem(RELOAD_AT_KEY, String(Date.now()));
				} catch {
					// ignore
				}
				window.location.reload();
				// Never resolves: the page is reloading.
				return new Promise(() => {});
			}
			throw error;
		})
	);
}
